<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="İçerik Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru bağlantı linki
                benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/contents/create/${categorySlugParam}`"
          >
            Yeni İçerik Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="İçerikler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>İÇERİK</th>
                    <th>KATEGORİ</th>
                    <th>DURUM</th>
                    <th>YAYIN T.</th>
                    <th>TARİH</th>
                    <!-- <th>ÖNİZLEME</th> -->
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="contents"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="content in contents" :key="content.id">
                      <td>{{ content.id }}</td>
                      <td>{{ content.title }}</td>
                      <td>{{ content.category.name }}</td>
                      <td>
                        <b-badge v-if="content.isDraft == false" variant="light-success">
                          Yayında
                        </b-badge>
                        <b-badge v-if="content.isDraft == true" variant="light-warning">
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ content.releaseDate }}</td>
                      <td>{{ content.createdAt }}</td>
                      <!-- <td>
                        <b-button-group>
                          <b-button
                            title="Önizleme"
                            @click="actionPreview(content, $i18n.locale)"
                            variant="outline-primary"
                          >
                            Önizleme
                          </b-button>
                        </b-button-group>
                      </td> -->
                      <td>
                        <b-button-group class="float-right">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="deleteConfirmText(content.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                        <b-button-group class="float-right mr-2">
                          <b-button
                            v-for="language in languages"
                            :key="language.locale"
                            @click="action(content, language.locale)"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="
                              content.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            "
                            :title="
                              content.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'Düzenle'
                                : 'Ekle'
                            "
                          >
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>İÇERİK</th>
                    <th>KATEGORİ</th>
                    <th>DURUM</th>
                    <th>YAYIN T.</th>
                    <th>TARİH</th>
                    <!-- <th>ÖNİZLEME</th> -->
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      contents: [],
      languages: [],
      categorySlugParam: this.$route.params.slugParam,
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
        this.$router.push({
          path: `/contents/create/translation/${node.slug}?targetLocale=${locale}&targetCategory=${node.category.slug}`,
        });
      } else {
        this.$router.push({
          path: `/contents/edit/${node.slugs[locale]}?targetLocale=${locale}&targetCategory=${node.category.slug}`,
        });
      }
    },
    actionPreview(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
      } else {
        window.open(
          `${settings.uiBaseUrl}/contents/preview/${node.slugs[locale]}?hl=${locale}`,
          "_blank"
        );
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.contents).forEach(([key, value]) => {
        let contentsOrder = {
          slug: value.slug,
          order: parseInt(key),
        };
        this.request.push(contentsOrder);
      });
      endpoints
        .putContentsOrder({ contents: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "İçerik sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getContentsByCategorySlug() {
      endpoints
        .getContentsByCategorySlug(this.categorySlugParam, this.$i18n.locale, () => {})
        .then((data) => {
          this.contents = [];
          this.contents = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "İçeriği silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteContents(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getContentsByCategorySlug();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "içerik silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getContentsByCategorySlug();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
